import { FullStory as FS, init } from "@fullstory/browser";
import { WindowWithAppConfig } from "./context/ConfigContext";
import { Environment } from "./types";

const targetEnvs = [Environment.PROD.toString(), Environment.CERT.toString()];
const getCurrentEnv = () =>
  ((window as WindowWithAppConfig).APP_CONFIG || {}).NODE_ENV;

export const FullStory = {
  initialise: ({ name: displayName, sub }: { name: string; sub: string }) => {
    const env = getCurrentEnv();
    if (!env || !targetEnvs.includes(env)) {
      return;
    }

    init({
      orgId: "o-1JHWR5-na1",
      recordOnlyThisIFrame: true,
    });

    FS("setIdentity", {
      uid: sub,
      properties: {
        displayName,
        sub,
      },
    });

    console.log("FullStory initialized");
  },
};
